"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.91 4.38h-.58V2.46h-4.51v1.92H.09v1h.58v8.41h14.66V5.38h.58v-1Zm-4.09-.92h2.51v.92h-2.51v-.92Zm2.51 9.34H6.35v-.76h-1v.76H1.67V5.38h3.68v5.59h1V5.38h7.98v7.42Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.88 6.757h-1.073v-2.88h-6.39v2.88H.135v1.125h1.057v12.623h21.615V7.882h1.073V6.757Zm-6.338-1.755h4.14v1.755h-4.14V5.002Zm4.14 14.378H9.345v-1.32H8.22v1.32H2.317V7.882H8.22v8.573h1.125V7.882h12.337V19.38Zm-6.712-4.125v-4.5h-4.5v4.5h4.5Zm-3.375-3.375h2.25v2.25h-2.25v-2.25Zm8.962-1.125h-4.5v4.5h4.5v-4.5Zm-1.125 3.375h-2.25v-2.25h2.25v2.25Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    d: "M31.84 9.01h-1.43V5.17h-8.52v3.84H.18v1.5h1.41v16.83h28.82V10.51h1.43v-1.5Zm-8.45-2.34h5.52v2.34h-5.52V6.67Zm5.52 19.17H12.46v-1.76h-1.5v1.76H3.09V10.51h7.87v11.43h1.5V10.51h16.45v15.33Zm-8.95-5.5v-6h-6v6h6Zm-4.5-4.5h3v3h-3v-3Zm11.95-1.5h-6v6h6v-6Zm-1.5 4.5h-3v-3h3v3Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    d: "M47.82 13.695h-2.4v-5.76H33.008v5.76H.143v1.875h2.43v25.245h42.855V15.57h2.4v-1.875h-.008Zm-4.275 0H39.57V9.81h3.975v3.885ZM34.883 9.81h2.805v3.885h-2.805V9.81Zm8.662 29.13h-25.05v-2.835H16.62v2.835H4.448V15.57H16.62v17.333h1.875V15.57h25.058v23.37h-.008Zm-13.8-8.625V21.69H21.12v8.625h8.625Zm-6.75-6.75h4.875v4.875h-4.875v-4.875ZM40.92 21.69h-8.625v8.625h8.625V21.69Zm-1.875 6.75H34.17v-4.875h4.875v4.875Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    d: "M63.76 18.26h-3.2v-7.68H44.01v7.68H.19v2.5h3.24v33.66h57.14V20.76h3.2v-2.5h-.01Zm-5.7 0h-5.3v-5.18h5.3v5.18Zm-11.55-5.18h3.74v5.18h-3.74v-5.18Zm11.55 38.84h-33.4v-3.78h-2.5v3.78H5.93V20.76h16.23v23.11h2.5V20.76h33.41v31.16h-.01Zm-18.4-11.5v-11.5h-11.5v11.5h11.5Zm-9-9h6.5v6.5h-6.5v-6.5Zm23.9-2.5h-11.5v11.5h11.5v-11.5Zm-2.5 9h-6.5v-6.5h6.5v6.5Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconRoofTypeFlat = function IconRoofTypeFlat(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Roof Type Flat' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "RoofTypeFlat"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconRoofTypeFlat.sizes = [16, 24, 32, 48, 64];
IconRoofTypeFlat.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconRoofTypeFlat;
exports.default = _default;